import template from './ecocode-trustpilot-connect.html.twig';
import './ecocode-trustpilot-connect.scss';

const {api} = Shopware.Context;

Shopware.Component.register('ecocode-trustpilot-connect', {
    template,
    inject: ['ecocodeTrustpilotConfigurationService'],
    emits:['frw-set-title','buttons-update','frw-redirect', 'modal-close'],
    computed: {
        connectLink() {
            const returnUrl = `${this.shopUrl}/${this.$router.resolve({name: 'ecocode.trustpilot.setup.connect'}).href}`;
            const clientId = 'mVyBRC8kZkEH6TP74gFmXX3SorZuSH1e';
            const redirectUrl = `https://trustpilot.ecocode.de/authenticate?return_url=${encodeURIComponent(returnUrl)}`;

            return `https://authenticate.trustpilot.com?response_type=code&client_id=${clientId}&redirect_uri=${encodeURI(redirectUrl)}`;
        },
        shopUrl() {
            return `${api.uri}`;
        }
    },

    async mounted() {
        if (this.$route.query.client_id) {
            await this.ecocodeTrustpilotConfigurationService.connect(this.$route.query);

            this.$emit('frw-redirect', 'ecocode.trustpilot.setup.configure');
            return;
        }

        const status = await this.ecocodeTrustpilotConfigurationService.status();

        if (status.isConnected) {
            this.$emit('frw-redirect', 'ecocode.trustpilot.setup.configure');
            return;
        }

        this.isLoading = false;
    },
    created() {
        this.createdComponent();
    },
    methods: {
        createdComponent() {
            this.updateButtons();
            this.setTitle();
        },
        setTitle() {
            this.$emit('frw-set-title', this.$tc('ecocode-trustpilot.connect.modalTitle'));
        },
        updateButtons() {
            const buttonConfig = [

                {
                    key: 'cancel',
                    label: this.$tc('ecocode-trustpilot.general.buttonCancel'),
                    position: 'right',
                    variant: null,
                    action: this.onCancel.bind(this),
                    disabled: false
                }
            ];

            this.$emit('buttons-update', buttonConfig);
        },
        onCancel() {
            this.$emit('modal-close');
        }
    },

    data() {
        return {
            isLoading: true
        };
    }
});
